
const propertyStatus = {
  ENABLE: 'enabled',
  DISABLE: 'disabled',
}

export function propertyStatusColor(status){
  if (!status || status === propertyStatus.ENABLE) {
    return '#67C23A'
  }
  if (!status || status === propertyStatus.DISABLE) {
    return '#F56C6C'
  }
}
export function propertyStatusTagType(status){
  if (!status || status === propertyStatus.ENABLE) {
    return 'success'
  }
  if (!status || status === propertyStatus.DISABLE) {
    return 'danger'
  }
}
export default propertyStatus;